import React from 'react';
import { Chip } from '@mui/material';
import { LeadPriority } from '../../types/lead.types';
import {
  KeyboardArrowUp,
  KeyboardDoubleArrowUp,
  Remove,
  PriorityHigh,
} from '@mui/icons-material';

interface PriorityBadgeProps {
  priority: LeadPriority;
  size?: 'small' | 'medium';
}

const priorityConfig: Record<LeadPriority, { label: string; color: any; icon: any }> = {
  low: { label: 'Low', color: 'default', icon: <Remove fontSize="small" /> },
  medium: { label: 'Medium', color: 'info', icon: <KeyboardArrowUp fontSize="small" /> },
  high: { label: 'High', color: 'warning', icon: <KeyboardDoubleArrowUp fontSize="small" /> },
  urgent: { label: 'Urgent', color: 'error', icon: <PriorityHigh fontSize="small" /> },
};

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority, size = 'small' }) => {
  const config = priorityConfig[priority];
  
  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      icon={config.icon}
      sx={{ fontWeight: 500 }}
    />
  );
};